export default __webpack_public_path__ + "static/media/outside.9fa173f4.jpg";